import * as React from "react";
import { StaticImage } from "gatsby-plugin-image";
import Seo from "/src/components/Seo";
import Layout from "/src/components/Layout";
import { graphql, useStaticQuery } from "gatsby";

import * as styles from "/src/css/blog.module.css";
import BlogCategories from "/src/components/Blog/BlogCategories";
import BlogByDate from "/src/components/Blog/BlogByDate";
import { FaArrowCircleRight } from "@react-icons/all-files/fa/FaArrowCircleRight";
import { useState } from "react";
import { send } from "emailjs-com";

const BlogPage = () => {
  const data = useStaticQuery(query);
  const posts = data.allContentfulBlogPost.nodes;
  const [email, setEmail] = useState("");
  const [valid, setValid] = useState(null);
  const [spinner, setSpinner] = useState(false);

  const onChange = (e) => {
    setEmail(e.target.value);
  };

  var templateParams = {
    email: email,
  };

  const keyPressHandler = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (email.match(mailformat)) {
      await setSpinner(true);
      await send(
        process.env.GATSBY_EMAILJS_SERVICE_ID,
        process.env.GATSBY_EMAILJS_BLOG_TEMPLATE_ID,
        templateParams,
        process.env.GATSBY_EMAILJS_USER_ID
      )
        .then((response) => {
          setTimeout(() => {
            setSpinner(false);
            setValid(true);
          }, 1000);
        })
        .catch((err) => {
          console.warn("FAILED...", err);
          alert("Sorry something went wrong! Please try again later.");
        });
    } else {
      setValid(false);
    }
  };

  return (
    <>
      <Seo title="Blog" />
      <div className={styles.blogTopSection}>
        <div className={styles.blogTitleWrapper}>
          <h1>The Magorium Blog</h1>
          <p>
            Articles written by our professional environmental enthusiasts
            written on a range of topics from home based recycling projects to
            community initiatives. Check them out below!
          </p>
        </div>
        <div className={styles.blogImageWrapper}>
          <StaticImage
            placeholder="tracedSVG"
            alt="Boy reading"
            src="../images/blog-reading-boy.png"
            width={350}
          />
        </div>
      </div>
      <div className={styles.blogWavyPart1} />
      <div className={styles.blogMiddleSection}>
        <div>
          <div>
            <BlogCategories data={posts} />
          </div>
          <div>
            <BlogByDate data={posts} />
          </div>
        </div>
      </div>

      <div className={styles.blogWavyPart2} />
      <div className={styles.blogBottomSection}>
        <div>
          <div className={styles.blogCallToAction}>Be a Contributor!</div>
          <div className={styles.inputContainer}>
            <input
              className={styles.blogEmailInput}
              type="email"
              placeholder="Enter your email!"
              onChange={onChange}
              onKeyPress={keyPressHandler}
            />
            {spinner ? (
              <div className={styles.spinner} />
            ) : (
              <FaArrowCircleRight
                onClick={handleSubmit}
                className={styles.submitButton}
                fontSize={30}
              />
            )}
          </div>
          <div
            className={styles.emailMessage}
            style={{ color: valid ? "green" : "red" }}
          >
            {valid === true
              ? "Done!"
              : valid === false
              ? "Enter a valid email!"
              : ""}
          </div>
        </div>
        <div className={styles.blogImageOfChildren}>
          <StaticImage
            placeholder="tracedSVG"
            alt="Your idea taking off"
            src="../images/blog-kids-playing.png"
            width={350}
          />
        </div>
      </div>
    </>
  );
};

export const query = graphql`
  {
    allContentfulBlogPost {
      nodes {
        category
        createdAt
        summary
        title
        createdBy
      }
    }
  }
`;
BlogPage.Layout = Layout;
export default BlogPage;
